import type { Ref } from 'react';
import React, { forwardRef } from 'react';
import type { DataGridCellRendererProps } from '@myosh/odin-components';
import { DataGridDataCell } from '@myosh/odin-components';
import { isNumber } from 'lodash';

function FixedNumberDataCell({ column, rowData }: DataGridCellRendererProps, forwardRef: Ref<HTMLDivElement>) {
  const cellValue = rowData[column.field];

  return (
    <DataGridDataCell
      ref={forwardRef}
      value={isNumber(cellValue) ? Number(cellValue).toFixed(2) : String(cellValue ?? '')}
      width={column.width}
    />
  );
}

export default forwardRef(FixedNumberDataCell);
